import { render, staticRenderFns } from "./LegalEntities.vue?vue&type=template&id=6cd65bac&scoped=true"
import script from "./LegalEntities.vue?vue&type=script&lang=js"
export * from "./LegalEntities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd65bac",
  null
  
)

export default component.exports